import * as React from "react";

import { Modal } from "src/library/components/Modal";
import { SchedulePreRequestUpdate } from "src/core/schedules/api/schedules.api";

interface ScheduleWarningModalProps {
  onConfirm: () => void;
  handleDismiss: () => void;
  data: SchedulePreRequestUpdate | null;
}

const ScheduleWarningModal: React.ReactFCWithChildren<ScheduleWarningModalProps> = ({
  onConfirm, handleDismiss, data
}) => {
  let message = "";

  if (data) {
    if (data.message) {
      message = data.message;
    } else {
      const createMessage = `attempt to create ${data.toCreate || 0}`;
      const cancelMessage = `attempt to cancel ${data.toCancel || 0}`;
      const affectedMessage = `attempt to update ${data.affectedOrders || 0}`;

      message += "This action ";
      message += !data.toCreate && !data.toCancel && !data.affectedOrders ? "won't affect any" : "will ";
      message += data.toCreate ? createMessage : "";
      message += data.toCreate && data.toCancel ? " and " : "";
      message += data.toCancel ? cancelMessage : "";
      message += data.affectedOrders ? affectedMessage : "";
      message += " orders.";
    }
  }

  return (
    <Modal
      small
      actions={[
        {
          name: "Go back",
          action: () => handleDismiss(),
          $buttonType: "secondary"
        },
        {
          name: "Confirm",
          action: () => {
            onConfirm();
            handleDismiss();
          },
          $buttonType: "primary"
        }
      ]}
      backgroundAction={() => handleDismiss()}
      body={data ? message : "This will affect orders."}
      type="confirm"
      title="Are you sure?"
      show={data !== null}
    />
  );
};

export default ScheduleWarningModal;
